import { startOfTomorrow } from 'date-fns/startOfTomorrow';

import { getZonedDate, ZonedDate } from '@eika-infrastruktur/date';

import type { Currency, Kid, ReceiptType } from '../../../../generated-types';
import { FormattedFuturePayment } from '../../../../utils/mapper/futurepaymentsUtil';
import { CommonPaymentState } from '../../form/CommonPaymentState';

export interface PaymentState extends CommonPaymentState {
    note: string;
    kid?: Kid;
    ownText?: string;
    firstBankingDateFromToday?: ZonedDate;
    receiptType?: ReceiptType;
    immediate?: boolean;
    currency: Currency;
    acceptDuplicate: boolean;
    hasInitialKid?: boolean;
}

const tomorrow = getZonedDate(startOfTomorrow());

export const paymentInitialState: PaymentState = {
    fromAccount: undefined,
    toAccount: undefined,
    amount: undefined,
    currency: 'NOK',
    note: '',
    kid: { value: '' },
    ownText: '',
    firstBankingDateFromToday: tomorrow,
    showFromAccounts: false,
    receiptType: undefined,
    immediate: false,
    futurePaymentAmount: undefined,
    acceptDuplicate: false,
    hasInitialKid: false,
    paymentDate: getZonedDate(),
};

export const getFutureState = (futurePayment: FormattedFuturePayment): PaymentState => ({
    ...paymentInitialState,
    paymentDate: getZonedDate(futurePayment.date),
    amount: Math.abs(futurePayment.amount),
    showFromAccounts: false,
    futurePaymentAmount: -futurePayment.amount,
    currency: futurePayment.currency,
});
